import { createFileRoute, Outlet, useNavigate, useMatches } from '@tanstack/react-router'
import { Library, House } from 'lucide-react'
import AppHeader from '@/components/app-header'
import { HistorySheet } from '@/components/history-sheet'
import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip'
import { Button } from '@/components/ui/button'
import { useHistorySheetStore } from '@/stores/history-sheet-store'
import { OnboardingProvider } from '@/components/onboarding-provider'
import { SettingsTabsNav } from '@/routes/_layout/_app/settings'

export const Route = createFileRoute('/_layout/_app')({ component: AppLayout })

function AppLayout() {
  const openHistorySheet = useHistorySheetStore((s) => s.open)
  const navigate = useNavigate()
  const matches = useMatches()
  const title = [...matches].reverse().find((m) => m.staticData?.title)?.staticData?.title
  const isSettings = matches.some((m) => m.fullPath.startsWith('/settings'))

  return (
    <OnboardingProvider>
      <AppHeader
        title={isSettings ? undefined : title}
        centerSlot={isSettings ? <SettingsTabsNav /> : undefined}
        rightSlot={
          <div className="flex items-center gap-2">
            <Tooltip>
              <TooltipTrigger asChild>
                <Button variant="ghost" className="h-10 w-10" onClick={() => navigate({ to: '/' })}>
                  <House className="size-5" />
                </Button>
              </TooltipTrigger>
              <TooltipContent>Domov</TooltipContent>
            </Tooltip>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button variant="ghost" className="h-10 w-10" onClick={openHistorySheet}>
                  <Library className="size-5" />
                </Button>
              </TooltipTrigger>
              <TooltipContent>Zgodovina</TooltipContent>
            </Tooltip>
          </div>
        }
      />
      <Outlet />
      <HistorySheet />
    </OnboardingProvider>
  )
}
